var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomiseHandshake(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0442 38.1709L51.8532 41.9789C52.5893 42.7156 53.0028 43.7145 53.0028 44.7559C53.0028 45.7973 52.5893 46.7962 51.8532 47.5329V47.5329C51.1166 48.2695 50.1175 48.6834 49.0757 48.6834C48.0339 48.6834 47.0349 48.2695 46.2982 47.5329L42.4912 43.7269",
    stroke: "#8C8CB7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.974 49.2439L38.761 51.0319C39.4923 51.7633 39.9031 52.7552 39.9031 53.7894C39.9031 54.8236 39.4923 55.8155 38.761 56.5469V56.5469C38.3988 56.9099 37.9684 57.1977 37.4946 57.3937C37.0207 57.5897 36.5128 57.69 36 57.6889",
    stroke: "#8C8CB7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 29V23L3 19L17 5L20 8H25",
    stroke: "#8C8CB7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6479 40.3673L11.6183 41.3968C10.0844 42.9308 10.0842 45.4177 11.618 46.9515C13.1518 48.4853 15.6387 48.4851 17.1727 46.9511L18.2022 45.9216C19.7362 44.3876 19.7363 41.9007 18.2026 40.3669C16.6688 38.8331 14.1819 38.8333 12.6479 40.3673Z",
    stroke: "#EF4400",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3424 50.8161L23.8163 51.3421C22.2933 52.8652 22.2933 55.3345 23.8163 56.8576C25.3394 58.3806 27.8087 58.3806 29.3317 56.8576L29.8578 56.3315C31.3809 54.8084 31.3809 52.3391 29.8578 50.8161C28.3348 49.293 25.8654 49.293 24.3424 50.8161Z",
    stroke: "#EF4400",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.631 40.3831L12.051 40.9631C11.6875 41.3274 11.2536 41.6139 10.7758 41.8052C10.298 41.9965 9.78632 42.0886 9.27182 42.0758C8.75732 42.0631 8.25079 41.9459 7.78305 41.7312C7.3153 41.5165 6.89612 41.2089 6.55102 40.8271V40.8271C5.90391 40.1113 5.55334 39.1762 5.57042 38.2114C5.58751 37.2467 5.97097 36.3245 6.64302 35.6321L7.22302 35.0391C7.92231 34.3237 8.87553 33.9129 9.87582 33.8958C10.8761 33.8788 11.8428 34.2569 12.566 34.9481V34.9481C12.9324 35.2977 13.2252 35.7169 13.4272 36.1813C13.6292 36.6456 13.7364 37.1456 13.7425 37.6519C13.7485 38.1583 13.6533 38.6607 13.4625 39.1297C13.2716 39.5987 12.9889 40.0249 12.631 40.3831V40.3831Z",
    stroke: "#EF4400",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2248 45.9026L17.9335 46.1939C16.4105 47.717 16.4105 50.1863 17.9335 51.7094C19.4565 53.2324 21.9259 53.2324 23.4489 51.7094L23.7403 51.4181C25.2633 49.895 25.2633 47.4257 23.7403 45.9026C22.2172 44.3796 19.7479 44.3796 18.2248 45.9026Z",
    stroke: "#EF4400",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.537 46.7759C45.8992 47.138 46.1866 47.568 46.3826 48.0412C46.5786 48.5144 46.6795 49.0217 46.6795 49.5339C46.6795 50.0461 46.5786 50.5533 46.3826 51.0265C46.1866 51.4997 45.8992 51.9297 45.537 52.2919V52.2919C44.8056 53.0231 43.8137 53.4339 42.7795 53.4339C41.7452 53.4339 40.7534 53.0231 40.022 52.2919L38.73 50.9999",
    stroke: "#8C8CB7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7761 40.9C51.1401 41.2635 51.5741 41.5493 52.0518 41.7401C52.5295 41.9309 53.041 42.0227 53.5552 42.01C54.0695 41.9973 54.5758 41.8803 55.0435 41.6661C55.5112 41.452 55.9305 41.145 56.2761 40.764V40.764C56.9232 40.0482 57.2738 39.1131 57.2567 38.1483C57.2396 37.1836 56.8561 36.2614 56.1841 35.569L43.4761 22.51",
    stroke: "#8C8CB7",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0002 29V23L61.0002 19L47.0002 5L44.0002 8H37.4471C35.8622 7.99991 34.2928 8.31205 32.8285 8.91859C31.3642 9.52513 30.0338 10.4142 28.9132 11.535L19.7072 21.106C19.1165 21.7091 18.7713 22.5104 18.7388 23.354C18.7064 24.1976 18.9888 25.0231 19.5314 25.6699C20.0739 26.3166 20.8376 26.7385 21.6739 26.8533C22.5103 26.9681 23.3594 26.7677 24.0562 26.291L33.8561 19.973C34.7024 20.9326 35.7454 21.6986 36.9143 22.219C38.0831 22.7393 39.3503 23.0018 40.6297 22.9885C41.9091 22.9752 43.1705 22.6865 44.3283 22.142C45.4861 21.5975 46.513 20.8099 47.3392 19.833",
    stroke: "#EF4400",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomiseHandshake);
export default __webpack_public_path__ + "static/media/Customise-Handshake.581d7f9eb4fe293092b727dfae3d778a.svg";
export { ForwardRef as ReactComponent };